export function removeChar(value, index) {
  return value.substring(0, index) + value.substring(index + 1)
}